import { useEffect, useState } from "react";
import Spinner from "../../../Plateforme/Atoms/Spinner";
import * as api from "../../../api"
import styled from "styled-components";
import Section from "../../Atoms/Section";
import H1 from "../../Atoms/H1";
import H2 from "../../Atoms/H2";
import BlueButton from "../../Atoms/BlueButton";
import Input from "../../Atoms/Input";
import BoldBlue from "../../Atoms/BoldBlue";

const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(min(400px,100%), 1fr));
    gap: 20px;
    align-items: baseline;
`;

const Card = styled.div`
    border: 1px solid #ccc;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
    flex: 1;
    width: min(400px,100%);
    margin: 0 auto;
`;

const CardContent = styled.div`
  padding: 15px;
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 15px;

    button {
        padding: 5px 15px;
        text-transform: unset;
    }
`;

const ActionButton = styled.button`
  &.primary {
    background-color: #0066cc;
    color: white;
  }
  
  &.secondary {
    background-color: #f5f5f5;
    color: #333;
  }
  
  &.success {
    background-color: #28a745;
    color: white;
  }
  
  &.danger {
    background-color: #dc3545;
    color: white;
  }
`;

const Form = styled.form`
  margin-bottom: 20px;
`;

const FormGroup = styled.div`
  margin-bottom: 15px;
`;

const FormLabel = styled.label`
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
`;

const FileInputContainer = styled.div`
  margin: 8px 0;
`;

const ErrorMessage = styled.div`
  color: #dc3545;
  padding: 15px;
  border: 1px solid #dc3545;
  border-radius: 4px;
  margin-bottom: 20px;
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 40px;
  background-color: #f5f5f5;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

const ImageContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  padding: 15px;
  background: #f5f5f5;

  img {
    width: 100%;
    height: 200px;
    object-fit: contain;
    background: white;
  }
`;

const ImageLabel = styled.span`
  font-size: 12px;
  color: #666;
  text-align: center;
  margin-top: 8px;
`;

const InfoText = styled.p`
  color: #666;
  font-size: 14px;
  margin-top: 10px;
  font-style: italic;
`;

const CahierDeStyle = () => {
  const [allCDC, setAllCDC] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    title: "",
    pdf: "",
  });
  const [editingId, setEditingId] = useState(null);
  const [showForm, setShowForm] = useState(false);

  const fetchAllCDC = async () => {
    setLoading(true);
    try {
      const res = await api.GetAllCahierDeStyle();
      setAllCDC(res.data);
      console.log("Cahiers de style récupérés:", res.data);
      setError(null);
    } catch (error) {
      console.error("Erreur lors de la récupération des cahiers de style:", error);
      // Si l'erreur est 404 (non trouvé), on ne considère pas comme une erreur
      // mais plutôt comme un état vide
      if (error.response && error.response.status === 404) {
        setAllCDC([]);
        setError(null);
      } else {
        setError("Échec du chargement des cahiers de style");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllCDC();
  }, []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    
    if (files && files[0]) {
      // Pour les entrées de fichiers
      setFormData({
        ...formData,
        [name]: files[0]
      });
    } else {
      // Pour les entrées de texte
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const data = new FormData();
      
      // Ajouter tous les champs du formulaire à FormData
      Object.keys(formData).forEach(key => {
        if (formData[key]) {
          data.append(key, formData[key]);
        }
      });

      if (editingId) {
        // Mettre à jour un CDC existant
        data.append('id', editingId);
        await api.UpdateCahierDeStyle(data);
      } else {
        // Créer un nouveau CDC
        await api.CreateCahierDeStyle(data);
      }
      
      // Réinitialiser le formulaire et récupérer les données mises à jour
      resetForm();
      fetchAllCDC();
    } catch (error) {
      console.error("Erreur lors de l'enregistrement du cahier de style:", error);
      setError("Échec de l'enregistrement du cahier de style");
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer ce cahier de style ?")) {
      setLoading(true);
      try {
        await api.DeleteCahierDeStyle({ id });
        fetchAllCDC();
      } catch (error) {
        console.error("Erreur lors de la suppression du cahier de style:", error);
        setError("Échec de la suppression du cahier de style");
        setLoading(false);
      }
    }
  };

  const handleEdit = (cdc) => {
    setFormData({
      title: cdc.title,
      pdf: cdc.pdf,
    });
    setEditingId(cdc._id);
    setShowForm(true);
    window.scrollTo(0, 0);
  };

  const resetForm = () => {
    setFormData({
      title: "",
      pdf: "",
    });
    setEditingId(null);
    setShowForm(false);
  };

  const ImagePreview = ({ src, label }) => (
    <div>
      <img src={src} alt={label} />
      <ImageLabel>{label}</ImageLabel>
    </div>
  );

  if (loading && allCDC.length === 0) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "300px" }}>
        <Spinner />
      </div>
    );
  }

  if (error) {
    return (
      <Section className="padding">
        <ErrorMessage>
          Erreur: {error}
        </ErrorMessage>
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <BlueButton onClick={() => setShowForm(true)}>
            Ajouter un nouveau cahier de style
          </BlueButton>
        </div>
      </Section>
    );
  }

  return (
    <div>
      <Section className="padding">
        <div className="flexblock">
          <H1>Cahiers de Style</H1>
          <div style={{textAlign: "right"}}>
            <BlueButton onClick={() => setShowForm(!showForm)}>
                {showForm ? "Annuler" : "Ajouter un nouveau cahier de style"}
            </BlueButton>
          </div>
        </div>
      </Section>

      {showForm && (
        <Section className="padding">
          <H2>{editingId ? "Modifier" : "Créer"} le cahier de style</H2>
          <br/>
          <Form onSubmit={handleSubmit}>
            <FormGroup>
              <FormLabel>Titre</FormLabel>
              <Input
                type="text"
                name="title"
                value={formData.title}
                onChange={handleChange}
                required
                style={{ width: "100%" }}
                placeholder="Titre du cahier de style"
              />
            </FormGroup>

            <FormGroup>
              <FormLabel>Document PDF</FormLabel>
              <FileInputContainer>
                <input
                  type="file"
                  name="pdf"
                  onChange={handleChange}
                  accept=".pdf"
                  required={!editingId}
                  style={{ width: "100%" }}
                />
              </FileInputContainer>
              {editingId && (
                <small style={{ color: "#999" }}>
                  Laissez vide pour conserver le PDF actuel
                </small>
              )}
              <InfoText>
                Les images de couverture et d'aperçu seront générées automatiquement à partir du PDF.
              </InfoText>
            </FormGroup>

            <div style={{ display: "flex", gap: "10px" }}>
              <BlueButton
                type="submit"
                disabled={loading}
              >
                {loading ? "Enregistrement..." : editingId ? "Mettre à jour" : "Créer"}
              </BlueButton>
              <ActionButton
                type="button"
                className="secondary"
                onClick={resetForm}
              >
                Annuler
              </ActionButton>
            </div>
          </Form>
        </Section>
      )}

      {loading && allCDC.length > 0 && (
        <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
          <Spinner />
        </div>
      )}

      <Section className="padding">
        {!loading && allCDC.length === 0 ? (
          <EmptyState>
            <p>Aucun cahier de style trouvé.</p>
            {!showForm && (
              <BlueButton onClick={() => setShowForm(true)}>
                Créer un nouveau cahier de style
              </BlueButton>
            )}
          </EmptyState>
        ) : (
          <Grid>
            {allCDC.map((cdc) => (
              <Card key={cdc._id}>
                <ImageContainer>
                  {cdc.firstPageImage ? (
                    <ImagePreview src={cdc.firstPageImage} label="Couverture" />
                  ) : (
                    <div>Aucune couverture</div>
                  )}
                  {cdc.previewImage ? (
                    <ImagePreview src={cdc.previewImage} label="Aperçu" />
                  ) : (
                    <div>Aucun aperçu</div>
                  )}
                </ImageContainer>
                <CardContent>
                  <H2 className="centered">{cdc.title}</H2>
                  <ButtonRow>
                    <button onClick={() => handleEdit(cdc)} style={{ cursor: "pointer" }}>
                      Modifier
                    </button>
                    <a
                      href={cdc.pdf}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none" }}
                    >
                      <button className="success">
                        Voir le PDF
                      </button>
                    </a>
                    <ActionButton
                      onClick={() => handleDelete(cdc._id)}
                      className="danger"
                    >
                      Supprimer
                    </ActionButton>
                  </ButtonRow>
                </CardContent>
              </Card>
            ))}
          </Grid>
        )}
      </Section>
    </div>
  );
};

export default CahierDeStyle;